export { default } from './promotional-modal';
export { promotionalModalHandler } from './promotional-modal.handler';
export type { PromotionalModalProperties } from './promotional-modal.types';
